import VueRouter from 'vue-router'
import Vue from 'vue'
import Mutation from '@/components/Mutation.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    // 指定路由和组件的对应关系
    routes: [
        { path: '/', redirect: '/mutation'},
        { path: '/mutation', component:Mutation}
    ]
})

export default router